import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const ReanalyzeConfirmModal = ({ isOpen, onClose, item, onConfirmReanalyze }) => {
    const [loading, setLoading] = useState(false);

    const handleConfirm = async () => {
        setLoading(true);
        try {
            await onConfirmReanalyze(item);
            onClose();
        } finally {
            setLoading(false);
        }
    };

    return (
        <AnimatePresence>
            {isOpen && item && (
                <div
                    onClick={onClose}
                    style={{
                        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 1100,
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        backgroundColor: 'rgba(15, 23, 42, 0.5)', backdropFilter: 'blur(4px)', padding: '1rem'
                    }}
                >
                    <motion.div
                        onClick={(e) => e.stopPropagation()}
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.95, y: 10 }}
                        transition={{ type: 'spring', damping: 25, stiffness: 300 }}
                        style={{
                            backgroundColor: '#ffffff', borderRadius: '1rem',
                            boxShadow: '0 20px 25px -5px rgba(0,0,0,0.1)',
                            width: '100%', maxWidth: '24rem', overflow: 'hidden'
                        }}
                    >
                        {/* Header */}
                        <div style={{
                            padding: '1.25rem 1.5rem', borderBottom: '1px solid #e0f2fe',
                            backgroundColor: '#f0f9ff', display: 'flex', alignItems: 'center', gap: '0.75rem'
                        }}>
                            <i className="pi pi-refresh" style={{ fontSize: '1.5rem', color: '#0284c7' }}></i>
                            <h3 style={{ margin: 0, fontSize: '1.1rem', fontWeight: 'bold', color: '#075985' }}>
                                Reanalizar documento
                            </h3>
                        </div>

                        {/* Body */}
                        <div style={{ padding: '1.25rem 1.5rem' }}>
                            <p style={{ margin: '0 0 0.75rem 0', fontSize: '0.9rem', color: '#334155' }}>
                                Se volverá a enviar <strong>{item.category}</strong> a la IA para nuevo análisis.
                            </p>
                            <div style={{
                                backgroundColor: '#fff7ed', border: '1px solid #fed7aa', borderRadius: '0.5rem',
                                padding: '0.75rem', display: 'flex', alignItems: 'flex-start', gap: '0.5rem'
                            }}>
                                <i className="pi pi-exclamation-triangle" style={{ color: '#f59e0b', marginTop: '2px' }}></i>
                                <span style={{ fontSize: '0.8rem', color: '#9a3412' }}>
                                    La revisión humana se reiniciará a <strong>Pendiente</strong>. Cualquier aprobación o rechazo previo se perderá.
                                </span>
                            </div>
                        </div>

                        {/* Footer */}
                        <div style={{
                            padding: '1rem 1.5rem', borderTop: '1px solid #e2e8f0',
                            display: 'flex', justifyContent: 'flex-end', gap: '0.75rem'
                        }}>
                            <button
                                onClick={onClose}
                                disabled={loading}
                                style={{
                                    padding: '0.5rem 1rem', borderRadius: '0.5rem', border: '1px solid #e2e8f0',
                                    backgroundColor: '#ffffff', color: '#475569', fontWeight: '500',
                                    fontSize: '0.875rem', cursor: 'pointer'
                                }}
                            >
                                Cancelar
                            </button>
                            <button
                                onClick={handleConfirm}
                                disabled={loading}
                                style={{
                                    padding: '0.5rem 1rem', borderRadius: '0.5rem', border: 'none',
                                    backgroundColor: '#0ea5e9', color: '#ffffff', fontWeight: '500',
                                    fontSize: '0.875rem', cursor: loading ? 'wait' : 'pointer',
                                    opacity: loading ? 0.7 : 1, display: 'flex', alignItems: 'center', gap: '0.5rem',
                                }}
                            >
                                {loading ? (
                                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '1rem' }}></i>
                                ) : (
                                    <i className="pi pi-refresh" style={{ fontSize: '1rem' }}></i>
                                )}
                                Confirmar Reanálisis
                            </button>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default ReanalyzeConfirmModal;
